import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "Central__Calendar",
  class: "page-layout"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 rounded task-manager-header" }, "Patient Task Manager", -1 /* HOISTED */)
const _hoisted_3 = {
  class: "card px-0 h-100",
  id: "App__Calendar"
}
const _hoisted_4 = { class: "d-flex flex-wrap flex-xl-nowrap w-100" }
const _hoisted_5 = { class: "d-flex flex-wrap flex-xl-nowrap align-items-center p-0 m-0 w-100" }
const _hoisted_6 = { class: "form-group me-2 mb-2 flex-shrink-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, "Date From:", -1 /* HOISTED */)
const _hoisted_8 = { class: "input-group date datepickerInput" }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_11 = { class: "form-group me-2 mb-2 flex-shrink-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, "Date To:", -1 /* HOISTED */)
const _hoisted_13 = { class: "input-group date datepickerInput" }
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group mb-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "date-to" }, "Filter by text:", -1 /* HOISTED */)
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text bg-transparent p-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search font-size-sm" })
  ])
], -1 /* HOISTED */)
const _hoisted_20 = { class: "col-auto d-flex flex-wrap-reverse flex-xl-nowrap row-gap-2 ms-auto me-0 p-0 mt-auto mb-auto btns-container" }
const _hoisted_21 = { class: "d-flex ms-auto" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "d-flex ms-auto ms-md-0" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "table-scroll-wrapper" }
const _hoisted_26 = { class: "table table-responsive-md border border-gray" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "bg-table-header" }
const _hoisted_29 = { class: "form-check custom-checkbox form-check-inline ms-1 me-0" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label highlight",
  for: "task-select-all"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", null, "Task Document", -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", null, "Date", -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", null, "Time", -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", null, "Status", -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", null, "Employee", -1 /* HOISTED */)
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "bg-table-header" }
const _hoisted_38 = { class: "form-check custom-checkbox form-check-inline ms-1 me-0" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label highlight",
  for: "task-select-all"
}, [
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Task Document ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Date ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Time ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Status ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Employee ")
const _hoisted_45 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_46 = ["colspan"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  class: "table-error"
}
const _hoisted_50 = ["colspan"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("template", null, null, -1 /* HOISTED */)
const _hoisted_54 = { key: 2 }
const _hoisted_55 = {
  key: 0,
  class: "form-check custom-checkbox form-check-inline ms-1 zindex-0"
}
const _hoisted_56 = ["id", "value"]
const _hoisted_57 = ["for"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientBulkReassign = _resolveComponent("PatientBulkReassign")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_ListLayout = _resolveComponent("ListLayout")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      _createVNode(_component_ListLayout, {
        "has-title": _ctx.hideTitle,
        "page-title": _ctx.patientName,
        "form-title": "Bulk Reassign",
        "show-form": _ctx.isAddItemRequested
      }, {
        "list-form": _withCtx(() => [
          _createCommentVNode(" FORM CONTENT "),
          _createVNode(_component_PatientBulkReassign, {
            application: _ctx.application,
            "agency-id": _ctx.agencyId,
            "patient-id": _ctx.patientId,
            "selected-task-id": _ctx.selectedTaskId,
            "selected-user-id": _ctx.selectedUserId,
            "date-from": _ctx.dateFrom,
            "date-to": _ctx.dateTo,
            "branch-id": _ctx.branchId,
            "page-reset": _ctx.pageReset,
            "close-reassign-form": _ctx.closeReassignForm
          }, null, 8 /* PROPS */, ["application", "agency-id", "patient-id", "selected-task-id", "selected-user-id", "date-from", "date-to", "branch-id", "page-reset", "close-reassign-form"])
        ]),
        "list-header": _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          autocomplete: "off",
                          name: "dateFrom",
                          value: _ctx.formatDateInput(_ctx.dateFrom)
                        }, null, 8 /* PROPS */, _hoisted_9),
                        _hoisted_10
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("input", {
                          name: "dateTo",
                          type: "text",
                          class: "form-control",
                          placeholder: "MM/DD/YYYY",
                          value: _ctx.formatDateInput(_ctx.dateTo)
                        }, null, 8 /* PROPS */, _hoisted_14),
                        _hoisted_15
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["getDate"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control border-end-0",
                      placeholder: "Start Typing",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.term) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.term]
                    ]),
                    _hoisted_19
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary ms-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.taskRefresh()))
                }, " Refresh "),
                _createElementVNode("button", {
                  type: "button",
                  disabled: _ctx.selectedTaskId.length === 0,
                  class: "btn btn-sm btn-primary ms-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteTask()))
                }, " Delete ", 8 /* PROPS */, _hoisted_22)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: _ctx.selectedTaskId.length === 0,
                  class: "btn btn-sm btn-primary ms-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openReassignForm()))
                }, " Reassign ", 8 /* PROPS */, _hoisted_24),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary ms-2",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectToEmployeeList()))
                }, " View Calendar ")
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("table", _hoisted_26, [
              (!_ctx.getHasData)
                ? (_openBlock(), _createElementBlock("thead", _hoisted_27, [
                    _createElementVNode("tr", _hoisted_28, [
                      _createElementVNode("th", null, [
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: "task-select-all",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeAllSelection()))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ]),
                          _hoisted_30
                        ])
                      ]),
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("thead", _hoisted_36, [
                    _createElementVNode("tr", _hoisted_37, [
                      _createElementVNode("th", null, [
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            id: "task-select-all",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectAll) = $event)),
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeAllSelection()))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.selectAll]
                          ]),
                          _hoisted_39
                        ])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "TaskName"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_40
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "StartDate"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_41
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "StartTime"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_42
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "Status"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_SortableTh, {
                          "sort-by": _ctx.sortBy,
                          onSortByUpdated: _ctx.sortByUpdated,
                          "sort-order": _ctx.sortOrder,
                          onSortOrderUpdated: _ctx.sortOrderUpdated,
                          "sort-string": "UserFirstName"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_44
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                      ])
                    ])
                  ])),
              _createElementVNode("tbody", null, [
                _createCommentVNode(" EMPTY "),
                (!_ctx.isLoading && !_ctx.isError && !_ctx.getHasData)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                      _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_48, 8 /* PROPS */, _hoisted_46)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" ERROR "),
                (!_ctx.isLoading && _ctx.isError)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                      _createElementVNode("td", { colspan: _ctx.columns }, [
                        _createVNode(_component_ErrorMessageHandler, {
                          title: "Task list",
                          onTryAgain: _cache[9] || (_cache[9] = ($event: any) => (_ctx.taskRefresh()))
                        })
                      ], 8 /* PROPS */, _hoisted_50)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" LOADING "),
                (_ctx.isLoading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.getLoadingCount, (i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: i,
                        class: "table-loading"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (j) => {
                          return (_openBlock(), _createElementBlock("td", { key: j }, _hoisted_52))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" LIST "),
              _hoisted_53,
              (!_ctx.isLoading && !_ctx.isError && _ctx.getHasData)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_54, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTasks, (task) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass(`${_ctx.selectedTaskId.includes(task.Id) ? 'select-row' : ''}`),
                        key: task.Id
                      }, [
                        _createElementVNode("td", null, [
                          (!_ctx.isReadOnlyTask(task))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "form-check-input",
                                  id: `task_${task.Id}`,
                                  value: task,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedTaskId) = $event)),
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.taskChanged($event)))
                                }, null, 8 /* PROPS */, _hoisted_56), [
                                  [_vModelCheckbox, _ctx.selectedTaskId]
                                ]),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: `task_${task.Id}`
                                }, _hoisted_59, 8 /* PROPS */, _hoisted_57)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(task.TaskName), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(task.StartDate, "MM/DD/YY")), 1 /* TEXT */),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getVisitTime(task)), 1 /* TEXT */),
                        _createElementVNode("td", null, [
                          _createVNode(_component_EmptyTextHandler, {
                            text: task.Status
                          }, null, 8 /* PROPS */, ["text"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getFullName(task)), 1 /* TEXT */)
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["has-title", "page-title", "show-form"])
    ])
  ]))
}